import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Apresentacao } from '../../models/apresentacao.model';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApresentacaoResolverId } from '../../resolver/apresentacao.resolver';

@Component({
  selector: 'app-apresentacao-filtro',
  templateUrl: './apresentacao-filtro.component.html',
  styleUrls: ['./apresentacao-filtro.component.scss']
})
export class ApresentacaoFiltroComponent extends BaseFormComponent<Apresentacao> implements OnInit {
  @Input() id:number;
  @Output() closeFilter = new EventEmitter<void>();
  filterData:any = null;
  filters:any;

  constructor(
    public activatedRoute: ActivatedRoute,
    private apresentacaoResolverId: ApresentacaoResolverId
  ) { 
    super(activatedRoute);
  }

  ngOnInit() {
    this.start();
    this.initForm();
  }
  start(){
    this.apresentacaoResolverId.getById( this.id ).subscribe({
        next: (data) => {
          this.entity = data;
          this.filters = data.filter;
          this.filterData = data.currentFilter;
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          console.log(error)
          this.msgError(error.error.message);
        }
      })
  }
  initForm() {
    this.form = new FormGroup({
      agency_id: new FormControl([]),
      pf_ind_current_table_status: new FormControl([]),
      pf_ind_analysis_stat_id: new FormControl([]),
      enabled: new FormControl([]),
    });
    if (this.filterData) {
      this.form.patchValue(this.filterData);
    }
  }

  getDataCreate() {
    return Object.assign({}, this.form.value);
  }
  
  filtrar(){
    var data = {...this.entity, 'currentFilter': this.getDataCreate()};
    sessionStorage.setItem('dataMeeting' + this.id, JSON.stringify(data));
    window.location.reload()
  }

  onCloseFilter(){
    this.closeFilter.emit();
  }
}
